<template>
	<section class="page">
		<div class="row row-eq-height" v-loading="loadings.main" v-if="userPrivilegeMapping[70]"></div>
	</section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			loadings: {
				main: false,
			},
			counts: { wait_check: 0, wait_send: 0 },
			orderInfo: { count: 0, sum_total_price: 0 },
			inboundInfo: { count: 0, sum_total_price: 0 },
			outboundInfo: { count: 0, sum_total_price: 0 },
			stIncomeInfo: { count: 0, sum_total_price: 0 },
			stOutcomeInfo: { count: 0, sum_total_price: 0 },
		};
	},
	computed: {
		...mapState(["mainMenuActiveIndex", "hasMenuBar", "userInfo", "userPrivilegeMapping"]),
	},
	created() {},
	mounted() {
		this.refreshData();
	},
	methods: {
		goTo(where, tab) {
			this.$router.push({
				name: where,
				params: tab ? { tab: tab } : {},
			});
		},
		refreshData() {
			// this.loadings.main = true;
			// this.$axios
			// 	.post("/manage/dashboard")
			// 	.then(json => {
			// 		this.loadings.main = false;
			// 		this.counts = json.data.counts;
			// 		this.orderInfo = json.data.order_info;
			// 		if (json.data.tx_info[20]) {
			// 			this.outboundInfo = json.data.tx_info[20];
			// 		}
			// 		if (json.data.tx_info[21]) {
			// 			this.inboundInfo = json.data.tx_info[21];
			// 		}
			// 		if (json.data.tx_info[31]) {
			// 			this.stIncomeInfo = json.data.tx_info[31];
			// 		}
			// 		if (json.data.tx_info[32]) {
			// 			this.stOutcomeInfo = json.data.tx_info[32];
			// 		}
			// 	})
			// 	.catch(json => {
			// 		this.loading = false;
			// 		this.$message.error(json.data.msg);
			// 	});
		},
	},
	watch: {},
	components: {},
};
</script>
<style lang="scss" scoped>
</style>
